// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.eo-button.is-centered[data-v-7b1ea485]{max-width:400px}.all-programs[data-v-7b1ea485]{align-items:center;display:flex}.all-programs__az[data-v-7b1ea485]{font-size:18px}@media(max-width:600px){.all-programs__az[data-v-7b1ea485]{display:none}}.footer-text[data-v-7b1ea485]{color:#000;margin:40px 0 40px 70px;max-width:517px}@media(max-width:600px){.footer-text[data-v-7b1ea485]{margin:40px 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
